import {
  AccountClient,
  GET_ALL_TAX,
  GET_SERVICE_CATALOG_ITEMS_FOR_TABLE,
  GET_SERVICE_CATEGORIES
} from '@nile/graphql';
import { getTranslatedText } from '@nile/components';

export const getClient = (field) => {
  return AccountClient;
};

export const getVariables = (field) => {
  switch (field) {
    case 'taxId':
    case 'category':
      return {};
    case 'bundledItems':
      return {
        listInfo: {
          sort: [
            {
              attribute: 'name',
              order: 'ASC'
            }
          ],
          condition: {
            joinOperator: 'AND',
            operands: [
              {
                attribute: 'serviceTypeItem.offeringType',
                operator: 'includes',
                value: ['BLOCK_HOUR', 'BLOCK_MONEY', 'SERVICE_BUNDLE']
              }
            ]
          }
        }
      };
    default:
      return undefined;
  }
};

export const getQuery = (field) => {
  switch (field) {
    case 'taxId':
      return GET_ALL_TAX;
    case 'category':
      return GET_SERVICE_CATEGORIES;
    case 'bundledItems':
      return GET_SERVICE_CATALOG_ITEMS_FOR_TABLE;
    default:
      return null;
  }
};

export const callQuery = (field) => {
  const query = getQuery(field);
  const client = getClient(field);
  const variables = getVariables(field);

  switch (field) {
    case 'taxId':
    case 'category':
      return client?.query({ query, variables });
    default:
      return [];
  }
};

export const getSelectOptions = (field) => {
  return [];
};

const getQueryName = (field) => {
  switch (field) {
    case 'taxId':
      return 'getAllTax';
    case 'category':
      return 'getServiceCategories';
    default:
      return '';
  }
};

export const shapeOptions = (field, options) => {
  const key = getQueryName(field);
  switch (field) {
    case 'taxId':
      return options?.data?.[key].map((el) => {
        return {
          value: `${el.taxId}`,
          label: `${el.name}`
        };
      });
    case 'category':
      return options?.data?.[key].map((el) => {
        return {
          value: `${el.categoryId}`,
          label: `${el.name}`
        };
      });
    default:
      return options;
  }
};

export const getNewServiceCatalogImportFields = (intl, currentProduct) => {
  if (currentProduct !== 'MSP') {
    return [
      {
        label: 'common.name',
        key: 'name',
        validators: [
          {
            validate: 'required',
            errorMessage: 'dromo.validation.requiredField'
          },
          {
            validate: 'unique_case_insensitive',
            errorMessage: 'dromo.validation.unique'
          }
        ]
      },
      {
        label: 'admin.serviceCatalog.itemDescription',
        key: 'description'
      },
      {
        label: 'admin.serviceCatalog.serviceCategory',
        key: 'category'
        // type: 'select',
        // selectOptions: []
      }
    ];
  }
  return [
    {
      label: 'common.name',
      key: 'name',
      validators: [
        {
          validate: 'required',
          errorMessage: 'dromo.validation.requiredField'
        },
        {
          validate: 'unique_case_insensitive',
          errorMessage: 'dromo.validation.unique'
        }
      ]
    },
    {
      label: 'admin.serviceCatalog.itemDescription',
      key: 'description'
    },
    {
      label: 'admin.serviceCatalog.serviceCategory',
      key: 'category'
      // type: 'select',
      // selectOptions: []
    },
    {
      label: 'Service Item Type',
      key: 'itemType',
      type: 'select',
      selectOptions: [
        {
          label: 'Product',
          value: 'PRODUCT'
        },
        {
          label: 'Service',
          value: 'SERVICE'
        }
      ],
      validators: [
        {
          validate: 'required',
          errorMessage: 'dromo.validation.requiredField'
        }
      ]
    },
    {
      label: 'Service Offering Type',
      key: 'offeringType',
      type: 'select',
      selectOptions: [
        {
          label: 'Quantity',
          value: 'QUANTITY'
        },
        {
          label: 'Hours',
          value: 'HOURS'
        },
        {
          label: 'Block hour',
          value: 'BLOCK_HOUR'
        },
        {
          label: 'Block Money',
          value: 'BLOCK_MONEY'
        },
        {
          label: 'Service Bundle',
          value: 'SERVICE_BUNDLE'
        }
      ]
    },
    {
      label: 'Apply to ticket and project',
      key: 'offerAsWorklogItem',
      type: 'select',
      selectOptions: [
        {
          label: 'app.common.true',
          value: 'true'
        },
        {
          label: 'app.common.false',
          value: 'false'
        }
      ]
    },
    {
      label: 'Cost Price',
      key: 'costPrice',
      type: 'number'
    },
    {
      label: 'Unit Price',
      key: 'unitPrice',
      type: 'number'
    },
    {
      label: 'After Hours Price',
      key: 'afterHoursPrice',
      type: 'number'
    },
    {
      label: 'Round up to the nearest',
      key: 'roundUpValue',
      type: 'number',
      validators: [
        {
          validate: 'regex_match',
          regex: '^(?:[1-9]|[1-5][0-9]|60)$',
          errorMessage: 'dromo.validation.roundupRange'
        }
      ]
    },
    {
      label: 'Redeemable Quantity',
      key: 'quantity',
      type: 'number'
    },
    {
      label: 'Applicable Type',
      key: 'applicableType',
      type: 'select',
      selectOptions: [
        {
          label: 'All Items',
          value: 'ALL_ITEMS'
        },
        {
          label: 'Included Items',
          value: 'INCLUDED_ITEMS'
        }
      ]
    },
    {
      label: 'Applicable Hours',
      key: 'applicableHours',
      type: 'select',
      selectOptions: [
        {
          label: 'Business Hours',
          value: 'BUSINESS_HOURS'
        },
        {
          label: 'All Hours',
          value: 'ALL_HOURS'
        }
      ]
    },
    {
      label: 'Bundled Items',
      key: 'bundledItems',
      description: getTranslatedText(
        intl,
        'dromo.description.multiSelectItems',
        {
          fieldName: 'Bundled Items'
        }
      )
      // type: 'select',
      // selectOptions: []
    },
    {
      label: 'Taxable',
      key: 'taxable',
      type: 'select',
      selectOptions: [
        {
          label: 'app.common.true',
          value: 'true'
        },
        {
          label: 'app.common.false',
          value: 'false'
        }
      ]
    },
    {
      label: 'Tax',
      key: 'taxId',
      type: 'select',
      selectOptions: []
    }
  ];
};

export const getServiceCatalogImportFields = (intl, currentProduct) => {
  const serviceItemFields = [
    {
      label: 'common.name',
      key: 'name',
      validators: [
        {
          validate: 'required',
          errorMessage: 'dromo.validation.requiredField'
        },
        {
          validate: 'unique_case_insensitive',
          errorMessage: 'dromo.validation.unique'
        }
      ]
    },
    {
      label: 'admin.serviceCatalog.itemDescription',
      key: 'description'
    },
    {
      label: 'admin.serviceCatalog.serviceCategory',
      key: 'category'
      // type: 'select',
      // selectOptions: []
    }
  ];

  if (currentProduct == 'MSP') {
    serviceItemFields.push(
      {
        label: 'dromo.title.quantityType',
        key: 'quantityType',
        type: 'select',
        selectOptions: [
          {
            label: 'admin.serviceCatalog.quantityType.units',
            value: 'UNITS'
          },
          {
            label: 'admin.serviceCatalog.quantityType.worklogHours',
            value: 'HOURS'
          },
          {
            label: 'admin.serviceCatalog.quantityType.blockHours',
            value: 'BLOCK_HOURS'
          },
          {
            label: 'admin.serviceCatalog.quantityType.blockMoney',
            value: 'BLOCK_MONEY'
          }
        ],
        validators: [
          {
            validate: 'required',
            errorMessage: 'dromo.validation.requiredField'
          }
        ]
      },
      {
        label: 'admin.serviceCatalog.unitPrice',
        key: 'unitPrice',
        type: 'number',
        validators: [
          {
            validate: 'required',
            errorMessage: 'dromo.validation.requiredField'
          }
        ]
      },
      {
        label: 'attribute.afterHours.unitPrice',
        key: 'afterHoursPrice',
        type: 'number'
      },
      {
        label: 'admin.serviceCatalog.taxConfiguration.salesTaxEnabled',
        key: 'taxable',
        type: 'select',
        selectOptions: [
          {
            label: 'app.common.true',
            value: 'true'
          },
          {
            label: 'app.common.false',
            value: 'false'
          }
        ]
      },
      {
        label: 'app.article.tax',
        key: 'taxId',
        type: 'select',
        selectOptions: []
      },
      {
        label: 'dromo.title.roundUpTimeToNearest',
        key: 'roundUpTimeToTheNearest',
        type: 'select',
        selectOptions: [
          {
            label: '5',
            value: '5'
          },
          {
            label: '10',
            value: '10'
          },
          {
            label: '15',
            value: '15'
          },
          {
            label: '30',
            value: '30'
          }
        ]
      },
      {
        label: 'dromo.title.blockHourQuantity',
        key: 'blockHoursQuantity',
        type: 'number'
      },
      {
        label: 'dromo.title.blockMoneyAmount',
        key: 'blockMoneyAmount',
        type: 'number'
      },
      {
        label: 'admin.serviceCatalog.blockHours.applicableIn',
        key: 'applicableIn',
        type: 'select',
        selectOptions: [
          {
            label: 'admin.serviceCatalog.blockHourTypes.businessHours',
            value: 'BUSINESS_HOURS'
          },
          {
            label: 'admin.serviceCatalog.blockHourTypes.allHours',
            value: 'ALL_HOURS'
          }
        ]
      },
      {
        label: 'dromo.title.adjustAgainstAllItems',
        key: 'adjustAgainstAllItems',
        type: 'select',
        selectOptions: [
          {
            label: 'app.common.true',
            value: 'true'
          },
          {
            label: 'app.common.false',
            value: 'false'
          }
        ]
      },
      {
        label: 'dromo.title.adjustableItems',
        key: 'adjustableItems',
        description: getTranslatedText(
          intl,
          'dromo.description.adjustableItems'
        )
      }
    );
  }
  return serviceItemFields;
};
